





























import Vue, { PropType } from 'vue';
import { IEmployee, TimeOffTemplateFieldError } from '@/models';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';

export default Vue.extend({
  name: 'EmployeeTimeOffEntitlementYearPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, String],

    label: {
      type: String,
      default: 'Time Off Entitlements'
    },

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | TimeOffTemplateFieldError>,
      default: () => []
    },

    employee: Object as PropType<IEmployee>
  },

  data() {
    return {
      lazyValue: this.value,
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    },

    employee: {
      handler(value) {
        if (value && value.id) {
          this.genEmployeeEntitlementYears(value.id);
        }
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      getEmployeeTimeOffEntitlementYears:
        'employeeTimeOff/getEmployeeTimeOffEntitlementYears'
    }),

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];

      if (!(this.externalErrorMessage instanceof TimeOffTemplateFieldError)) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    },

    employeeTimeOffEntitlementYears(): number[] {
      return this.getEmployeeTimeOffEntitlementYears;
    }
  },

  methods: {
    ...mapActions({
      fetchEmployeeTimeOffEntitlementYears:
        'employeeTimeOff/fetchEmployeeTimeOffEntitlementYears'
    }),

    clearErrors() {
      this.errorMessage = '';
      this.errorMessageList.splice(0, this.errorMessageList.length);
      this.$emit('clearErrors');
    },

    genEmployeeEntitlementYears(employee: number) {
      this.clearErrors();
      this.loading = true;
      this.fetchEmployeeTimeOffEntitlementYears(employee)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    }
  }
});
